import React from 'react';
import { Helmet } from 'react-helmet';
import WelcomeHeader from './components/WelcomeHeader';
import LoginForm from './components/LoginForm';
import SocialLogin from './components/SocialLogin';
import RegisterPrompt from './components/RegisterPrompt';
import TrustSignals from './components/TrustSignals';

const LoginPage = () => {
  return (
    <div className="min-h-screen" style={{ background: '#0A0A0B' }}>
      <Helmet>
        <title>Sign In - Form Forge | Your Wellness Journey Starts Here</title>
        <meta name="description" content="Sign in to Form Forge to continue your personalized health and wellness tracking journey. Secure access to your health metrics, goals, and progress reports." />
        <meta name="keywords" content="login, sign in, health tracking, wellness app, Form Forge" />
      </Helmet>

      <div className="flex flex-col items-center justify-center min-h-screen px-4 py-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <WelcomeHeader />
              <LoginForm />
              <SocialLogin />
            </div>
            <div className="order-1 lg:order-2 flex flex-col items-center justify-center">
              <RegisterPrompt />
            </div>
          </div>
          <TrustSignals />
        </div>
      </div>

      {/* Background mesh gradient orbs */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full opacity-[0.06]" style={{ background: 'radial-gradient(circle, #FF6B00, transparent)', filter: 'blur(40px)' }}></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full opacity-[0.05]" style={{ background: 'radial-gradient(circle, #00D4FF, transparent)', filter: 'blur(60px)', animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full opacity-[0.04]" style={{ background: 'radial-gradient(circle, #AAFF00, transparent)', filter: 'blur(80px)', animationDelay: '2s' }}></div>
      </div>
    </div>
  );
};

export default LoginPage;